import { makeStyles } from 'tss-react/mui';

const name = 'BillingTabs';

export const useBillingTabsStyles = makeStyles({ name })(theme => ({
  root: {
    minHeight: 'unset',

    boxShadow: `inset 0 -1px 0 0 ${theme.palette.grey[200]}`,
  },
  flexContainer: {
    '&&': {
      gap: theme.spacing(5),

      [theme.breakpoints.down('md')]: {
        gap: theme.spacing(4),
      },
    },
  },
  indicator: {
    '&&': {
      height: 2,
    },
  },
}));
